import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {VersionDto} from "../../core/dtos/changelog/version-dto";

@Component({
  selector: 'yo-changelogs-drop-menu',
  templateUrl: './changelogs-drop-menu.component.html',
  styleUrls: ['./changelogs-drop-menu.component.scss'],
  standalone: false
})
export class ChangelogsDropMenuComponent implements OnInit {

  @Input() versions: VersionDto[] = [];
  @Input() defaultVersionSelected: VersionDto | null = null;

  @Output() versionSelected = new EventEmitter<VersionDto>()

  openStateOfList: Map<string, boolean> = new Map<string, boolean>();

  ngOnInit(): void {
    if (this.defaultVersionSelected) {
      this.selectVersion(this.defaultVersionSelected);
    }

    this.versions.forEach(version => {
      if (version.subVersions && version.subVersions.length > 0) {
        this.openStateOfList.set(version.number, false);
      }
    });
  }

  isVersionSelected(version: VersionDto): boolean {
    if (!this.defaultVersionSelected) {
      return false;
    }
    if (this.defaultVersionSelected?.number.length > 3 ) {
      this.openStateOfList.set(this.defaultVersionSelected?.number.slice(0, 3), true);
    }

    return this.defaultVersionSelected.number === version.number;
  }

  defaultIconClass(version: VersionDto): string {
    return version.subVersions.length === 0 ? 'fa-clipboard-list' : 'fa-chevron-down';
  }

  toggleSubVersionOpen(versionNumber: string): void {
    const currentState = this.openStateOfList.get(versionNumber) || false;
    this.openStateOfList.set(versionNumber, !currentState);
  }

  selectVersion(version: VersionDto): void {
    this.versionSelected.emit(version);
  }

  checkIfSubVersionOpen(versionNumber: string): boolean {
    return this.openStateOfList.get(versionNumber) || false;
  }
}
